/**
 * Route IDs and the path → routeId map.
 *
 * Verbatim from RW-ERP-Service/src/types/constants/route.ts so React's
 * permission lookups produce IDENTICAL results to Vue's.
 *
 * The IDs intentionally match the Vue source — do not regenerate. Permission
 * decisions on the server key off these exact UUIDs.
 */

export const specificationRouteId = '1bdc301d-0d1f-4f48-8f99-ef9768f71115';
export const materialCombinationRouteId = '5c86b637-7f9e-48da-9ca3-0a47eb4caf14';
export const ordersRouteId = '3152fb0f-d4c3-421b-8b4f-805ef3764d4b';
export const jobsRouteId = 'fbf8becb-818c-4752-96cb-2c1dc94957e3';
export const ideationProduct = 'fbf8becb-818c-4752-96cb-2c1dc94957e2';
export const enrichProduct = 'bdc0a44d-a0b6-471b-b0e3-81e08e753524';
export const containerRouteId = 'f2dfcf77-bc04-401f-a3cc-2fa4baed0230';
export const poRouteId = 'f2dfcf77-bc04-401f-a3cc-2fa4baed0231';
export const myPOs = 'f2dfcf77-bc04-401f-a3cc-2fa4baed0232';
export const onHoldPOs = 'f2dfcf77-bc04-401f-a3cc-2fa4baed0233';
export const allPOs = 'f2dfcf77-bc04-401f-a3cc-2fa4baed0234';
export const vendorReview = 'fbf8becb-818c-4752-96cb-2c1dc94957e4';
export const shipmentRouteId = 'f2dfcf77-bc04-401f-a3cc-2fa4baed0235';
export const incomingInventoryRouteId = 'fbf8becb-818c-4752-96cb-2c1dc94957e4';
export const archivedInventoryRouteId = 'fbf8becb-818c-4752-96cb-2c1dc94957f4';
export const outOfStockRouteId = 'fbf8becb-818c-4752-96cb-2c1dc94957e5';
export const inStockRouteId = 'fbf8becb-818c-4752-96cb-2c1dc94957f1';
export const jetfreshRouteId = 'fbf8becb-818c-4752-96cb-2c1dc94957e7';
export const distributorRouteId = 'fbf8becb-818c-4752-96cb-2c1dc9495701';
export const compassRouteId = 'fbf8becb-818c-4752-96cb-2c1dc9495702';
export const amazonRouteId = 'fbf8becb-818c-4752-96cb-2c1dc9495703';
export const amazonDfRouteId = 'fbf8becb-818c-4752-96cb-2c1dc9495704';
export const ceoPricingRouteId = 'bc459de3-86c0-41c9-9300-dc19237ff641';
export const amazonPoRouteId = 'fbf8becb-818c-4752-96cb-2c1dc9495705';
export const amazonCanadaRouteId = 'fbf8becb-818c-4752-96cb-2c1dc9495706';
export const amazonSellerRouteId = 'fbf8becb-818c-4752-96cb-2c1dc94957e8';
export const usFoodsRouteId = 'fbf8becb-818c-4752-96cb-2c1dc94957e9';
export const usFoodsCsRouteId = 'fbf8becb-818c-4752-96cb-2c1dc9495710';
export const usFoodsDirectRouteId = 'fbf8becb-818c-4752-96cb-2c1dc9495711';
export const gfsRouteId = 'fbf8becb-818c-4752-96cb-2c1dc9495712';
export const gfsUsRouteId = 'fbf8becb-818c-4752-96cb-2c1dc9495713';
export const gfsCanadaRouteId = 'fbf8becb-818c-4752-96cb-2c1dc9495714';
export const gfsStoresRouteId = 'fbf8becb-818c-4752-96cb-2c1dc9495715';
export const usFoodsUsRouteId = 'fbf8becb-818c-4752-96cb-2c1dc9495716';
export const bradyRouteId = 'fbf8becb-818c-4752-96cb-2c1dc9495718';
export const baldorRouteId = 'fbf8becb-818c-4752-96cb-2c1dc9495719';
export const cwStockRouteId = 'fbf8becb-818c-4752-96cb-2c1dc9495720';
export const cwDirectRouteId = 'fbf8becb-818c-4752-96cb-2c1dc9495721';
export const cwDropshipRouteId = 'fbf8becb-818c-4752-96cb-2c1dc9495722';
export const chefsWarehouseRouteId = 'fbf8becb-818c-4752-96cb-2c1dc9495723';
export const singerEquipmentRouteId = 'fbf8becb-818c-4752-96cb-2c1dc9495724';
export const cwRouteId = 'fbf8becb-818c-4752-96cb-2c1dc9495725';
export const stagedOrdersRouteId = 'fbf8becb-818c-4752-96cb-2c1dc9495700';
export const ediDashboardRouteId = 'f2dfcf77-bc04-401f-a3cc-2fa4baed0236';
/**
 * KPI Dashboard — Vue parity with
 * `RW-ERP-Service/src/types/constants/route.ts:63`.
 *
 * Vue's AsideMenu (lines 1346-1350) treats this routeId specially: when
 * checking permission, it uses `DEFAULT_DASHBOARD_URL = '/dashboard'`
 * INSTEAD of the actual `/dashboard/dashboards/<uuid>` deep link. This
 * is because the per-user landing dashboard is a stable id that the
 * backend keys permissions off `/dashboard`. We add both forms to the
 * map below so either lookup hits the same routeId.
 */
export const kpiDashboardRouteId = 'f2dfcf77-bc04-401f-a3cc-2fa4baed0237';
/** Sales Summary / Sales Breakdown screens (Sales KPI feature). */
export const salesSummaryRouteId = '0f9dfcf1-ccfd-4960-b782-c8ab2dc5afc1';
export const salesBreakdownRouteId = 'a304907b-3c5d-4e98-9f4b-e60be37801f4';
/** Operation id gating the Sales Summary / Sales Breakdown screens. */
export const salesDashboardOperationId = '65b64148-3317-401e-b00b-b5d905f4d151';
export const vendorsRouteId = 'c8e1e6b2-7a3e-4b8d-9c6e-2f8a1e4d5b1c';
export const approvedRouteId = 'c8e1e6b2-7a3e-4b8d-9c6e-2f8a1e4d5b2c';
export const pendingApprovalRouteId = 'c8e1e6b2-7a3e-4b8d-9c6e-2f8a1e4d5b3c';
export const inActiveRouteId = 'c8e1e6b2-7a3e-4b8d-9c6e-2f8a1e4d5b4c';
export const syscoRouteId = 'fbf8becb-818c-4752-96cb-2c1dc9495726';
export const syscoDirectRouteId = 'fbf8becb-818c-4752-96cb-2c1dc9495727';
export const europeanImportsRouteId = 'fbf8becb-818c-4752-96cb-2c1dc9495728';
export const sotfRouteId = 'fbf8becb-818c-4752-96cb-2c1dc9495729';
export const produceProRouteId = 'fbf8becb-818c-4752-96cb-2c1dc9495730';
export const taoGroupRouteId = 'fbf8becb-818c-4752-96cb-2c1dc9495731';
export const legendsRouteId = 'fbf8becb-818c-4752-96cb-2c1dc9495732';
export const fourSeasonsRouteId = 'fbf8becb-818c-4752-96cb-2c1dc9495733';
export const sodexoRouteId = 'fbf8becb-818c-4752-96cb-2c1dc9495734';
export const storeFrontRouteId = 'fbf8becb-818c-4752-96cb-2c1dc9495735';
export const adminRouteId = 'fbf8becb-818c-4752-96cb-2c1dc9495736';
/**
 * Zoro — single-link Sales-orders customer (Vue parity: Tao Group / Northwood).
 * UUID verbatim from `RW-ERP-Service/src/types/constants/route.ts:82` —
 * backend-confirmed, do NOT regenerate.
 */
export const zoroRouteId = '2cc20211-f9ef-4095-bec6-d71bf626c1a4';
/**
 * Baldor DF / Baldor Warehouse — verbatim from `RW-ERP-Service/src/
 * types/constants/route.ts` (`production` branch): `baldorDfRouteId =
 * '...95737'`, `baldorWarehouseRouteId = '...95738'`, both genuinely
 * distinct from `baldorRouteId` and from each other.
 *
 * A previous pass here aliased both to `baldorRouteId` instead, on the
 * belief that `...95737` collided with `northwoodRouteId` — but that
 * collision was an illusion caused by THIS FILE's `northwoodRouteId`
 * itself carrying the wrong value (`...95737`, fixed below to the real
 * `...95742`). The alias "fix" silently broke something worse: these
 * constants double as keys into `urlPathConfiguration` (routeId -> its
 * active-match patterns), a plain object — three different IDs that
 * actually resolve to one JS value collapse onto ONE key, so whichever
 * of the three `urlPathConfiguration` entries was written LAST in that
 * file silently discarded the other two. In practice that made every
 * one of Baldor / Baldor DF / Baldor Warehouse match Baldor Warehouse's
 * pattern — clicking Baldor Warehouse lit up Baldor DF too, since
 * `isItemActive` for either id read the exact same (wrong) pattern.
 */
export const baldorDfRouteId = 'fbf8becb-818c-4752-96cb-2c1dc9495737';
export const baldorWarehouseRouteId = 'fbf8becb-818c-4752-96cb-2c1dc9495738';
export const allProductsInventoryRouteId = '43fa5c66-6a4b-49ac-be4e-d9c9da811bd1';
export const productExportRouteId = 'c46216a9-a270-11f0-954c-00505633f00e';
export const arContactsRouteId = '77562599-3eb5-40c7-bb53-a5c2034bface';

/**
 * CloseHub (Accounting → CloseHub) — React-only feature, month-end close.
 *
 * ADDED 2026-08-06: real backend UUID from `tbl_routes` — the route master
 * row was created through the app's own Settings → Route Management screen
 * (same mechanism as every other route master record, so the backend's
 * ES + cache sync ran through the normal write path — not raw SQL). Role
 * grants were made via Roles → Manage Permissions in RW-Users-Service.
 * CloseHub previously had NO route UUID at all (`skipPermissionCheck` in
 * menuConfig, no gate on the page shell) — this constant ends that state.
 * `RoutePermissionGate` is now enabled on this route's page shell
 * (`src/pages/CloseHub.tsx`).
 *
 * NOTE: this route gate is SEPARATE from and ADDITIONAL to CloseHub's
 * domain-based access/role gate (`useCloseHubIdentity` /
 * `resolveCloseHubRole`, RW-Users-Service "Accounting Close Hub" domain) —
 * a permission *domain* is not a *route* id. Both can fire independently.
 */
export const closeHubRouteId = "72ca1ec9-26a0-4555-a40d-cb90a8a85612";

/**
 * Shipping Prices — UUID FIXED to match Vue's source of truth.
 *
 * Earlier value `a1f3d2e9-4b6c-4f5a-9c2e-7e8f1a3b4c5d` was a React-local
 * fabricated UUID that did NOT match Vue's `route.ts:87`. The backend
 * permission snapshot keys off Vue's UUID, so React's lookups for
 * Shipping Prices silently returned `hasPermission: false` for every
 * user — the route was effectively hidden in the menu and gated by
 * AccessDenied even for permitted users.
 *
 * Vue source: `RW-ERP-Service/src/types/constants/route.ts:87`.
 */
export const shippingPricesRouteId = 'fbf8becb-818c-4752-96cb-2c1dc94957f8';
/**
 * API Keys — backend route UUID from tbl_routes.
 * route_path_url = '/settings/api-keys', route_description = 'API access settings'.
 */
export const apiKeysRouteId = 'fbf8becb-818c-4752-96cb-2c1dc94957f9';

/* ────────────────────────────────────────────────────────────────────
   Additional routeIds — Vue parity for menu entries we don't yet
   render in React but whose permissions are still part of the
   snapshot. Adding them here means:

     1. `hasPermissionForRoute()` can resolve the path → routeId for
        every page the backend authoritatively gates, even if React's
        UI hasn't surfaced the entry yet.
     2. Cross-app navigation (a Vue tab clicking these links → React
        following along) doesn't fall through the lookup and produce
        false-deny.

   All UUIDs verbatim from `RW-ERP-Service/src/types/constants/route.ts`
   lines 81-87 — do NOT regenerate.
   ───────────────────────────────────────────────────────────────── */
export const categoryAndCollectionRouteId =
  '5deb9c90-f63d-4f3f-ae2c-453633958242';
export const returnRouteId = 'fbf8becb-818c-4752-96cb-2c1dc9495741';
export const createCsReturnRouteId = 'fbf8becb-818c-4752-96cb-2c1dc9495740';
export const warehouseReturnRouteId = 'fbf8becb-818c-4752-96cb-2c1dc9495739';
export const variationGroupingRouteId = 'fbf8becb-818c-4752-96cb-2c1dc94957f5';
// Verbatim from RW-ERP-Service `production` route.ts. Was previously
// `...95737` here — that's actually `baldorDfRouteId`'s UUID (see the
// comment there); the wrong value made `urlPathConfiguration`'s
// object-key collision look like a Northwood/Baldor-DF clash when the
// real fix was just giving this constant its own correct value.
export const northwoodRouteId = 'fbf8becb-818c-4752-96cb-2c1dc9495742';
export const pendingCatalogsRouteId = '925b79f9-ef07-4dc0-ac9f-55ec3854ec04';
/**
 * Asana Sourcing / Purchasing dashboards — split into two independent route
 * permissions (each team grantable on its own), per the admin permission
 * screen's "Asana sourcing Dashboard" / "Asana purchasing Dashboard" routes.
 */
export const asanaSourcingRouteId = '77562599-3eb5-40c7-bb53-a5c2035bfade';
export const asanaPurchasingRouteId = '77562599-3eb5-40c7-bb53-a5c2036bfade';

/**
 * Operation permission IDs — backend-keyed UUIDs for action-level gates.
 * These are checked via hasOperationPermission(id) from PermissionContext,
 * NOT via hasPermissionForRoute. They are NOT in ROUTE_PERMISSIONS.
 */
/**
 * @deprecated Superseded by asanaSourcingRouteId / asanaPurchasingRouteId
 * (per-team route permissions). Kept defined only in case something else
 * still references it -- do not wire this into new gating logic.
 */
export const asanaDashboardOperationId = 'db826902-a459-4ca2-9eba-3d5164180b61';

/**
 * Ads & Sales Reconciliation (Amazon Ads) — backend route UUID from tbl_routes.
 * Vue source: `RW-ERP-Service/src/types/constants/route.ts:111`.
 */
export const amazonAdsRouteId = 'ddef3d20-9630-400a-a9f9-a390a5a51ecb';

/**
 * Path → routeId. Mirrors `routePermissions` in Vue. The lookup key MUST
 * match the route exactly (including any query string the Vue app uses).
 */
/**
 * Staged-order CW listing page (`/orders/staged-orders/cw-order`). Distinct
 * from `jetfreshRouteId` — Vue's `route.ts:69` comment: "Previously this
 * page reused jetfreshRouteId; it now has its own id so CW permissions/menu
 * are decoupled from JetFresh."
 *
 * 2026-07-28 regression note: commit 9d8dcbc pointed this path at
 * `jetfreshRouteId`, claiming Vue gates the CW page behind the Jet-Fresh
 * permission — Vue does not; it has this dedicated id. Re-verified
 * directly against Vue's `route.ts:69`. Requires a matching
 * tbl_routes/tbl_route_permissions grant in RW-Users-Service before CW
 * users can access the page — otherwise the menu item is hidden and the
 * route is denied (same caveat as Vue's own comment).
 */
export const cwStagedOrdersRouteId = 'b8f7f89d-672d-433e-bbad-a11ca02f3fe8';

// 2026-07-28 regression note: commit 9d8dcbc annotated the two Leadership
// ids below as "existing nowhere in Vue's route.ts" — that claim is false.
// Both exist verbatim at `route.ts:92,95` with identical values. Re-verified
// directly against the Vue source; do not "fix" these without checking
// route.ts first.
export const sampleOrdersRouteId = 'fbf8becb-818c-4752-96cb-2c1dc9495750';
// The second of the two Leadership ids referenced in the comment above —
// verbatim from Vue's `route.ts:97`. Was declared nowhere in this file
// until the Leadership rail was added to React's menu.
export const shipmentDashboardRouteId = 'fbf8becb-818c-4752-96cb-2c1dc9495760';

/**
 * Returns — Vue parity, `route.ts:100-103`. `createCsReturnRouteId` /
 * `warehouseReturnRouteId` / `returnRouteId` were already declared above
 * (lines 167-169) for cross-app alias resolution before React rendered the
 * rail; `unknownReturnRouteId` was never added.
 */
export const unknownReturnRouteId = 'd09345a4-651b-467b-81c1-3afcf3fa9310';

/**
 * Shipments (top-level rail, distinct from Purchasing → Shipment) — Vue
 * parity, `route.ts:115-118`.
 */
export const shipmentsAmazonPoRouteId = '1e107261-6e80-408a-ab10-9e2d77394eb4';
export const shipmentsAmazonPoCanadaRouteId = '122cfd88-306d-476e-9643-9bac2daa2108';
export const shipmentsUsFoodsRouteId = '38ec7db0-71f6-4acb-8e10-c869c6d29f7c';
export const shipmentsBaldorRouteId = '00b30de7-1695-4771-a258-6123576b4fc3';

/** Orders → Report Export (Vue label: "Report Export"). `route.ts` sourced. */
export const salesExportRouteId = 'fbf8becb-818c-4752-96cb-2c1dc94957f6';

export const ROUTE_PERMISSIONS: Record<string, string> = {
  '/products/ceo-pricing': ceoPricingRouteId,
  '/ceo-pricing': ceoPricingRouteId,
  // Detail route shares the same backend routeId; the `:productId` segment is
  // matched as a wildcard by hasPermissionForRoute's pattern fallback.
  '/ceo-pricing/:productId': ceoPricingRouteId,
  '/products/settings/specification': specificationRouteId,
  '/products/settings/specification?location=category': specificationRouteId,
  '/products/settings/specification?location=jobs': specificationRouteId,
  '/product/material-combinations': materialCombinationRouteId,
  '/product/material-combinations?active=working': materialCombinationRouteId,
  '/product/material-combinations?active=approved': materialCombinationRouteId,
  '/product/material-combinations?active=ideation': materialCombinationRouteId,
  '/product/category-and-collection': categoryAndCollectionRouteId,
  '/product/category-and-collection/NEW': categoryAndCollectionRouteId,
  '/orders': ordersRouteId,
  '/orders/order': ordersRouteId,
  '/orders/staged-orders/jetfresh': jetfreshRouteId,
  '/orders/sales-orders': distributorRouteId,
  '/orders/sales-orders/zoro': zoroRouteId,
  '/orders/staged-orders/cw-order': cwStagedOrdersRouteId,
  '/orders/sales-orders/all': distributorRouteId,
  '/orders/sales-orders/compass': compassRouteId,
  '/orders/sales-orders/northwood': northwoodRouteId,
  '/orders/sales-orders/brady': bradyRouteId,
  '/orders/sales-orders/baldor': baldorRouteId,
  '/orders/sales-orders/chefswarehouse/cw-stock': cwStockRouteId,
  '/orders/sales-orders/chefswarehouse/cw-direct': cwDirectRouteId,
  '/orders/sales-orders/chefswarehouse/cw-dropship': cwDropshipRouteId,
  '/orders/sales-orders/chefswarehouse': chefsWarehouseRouteId,
  '/orders/sales-orders/chefswarehouse/cw': cwRouteId,
  '/orders/sales-orders/singer-equipment': singerEquipmentRouteId,
  '/orders/sales-orders/sysco/sotf': sotfRouteId,
  '/orders/sales-orders/amazon': amazonRouteId,
  '/orders/sales-orders/amazon/amazon-df': amazonDfRouteId,
  '/orders/sales-orders/amazon/amazon-po': amazonPoRouteId,
  '/orders/sales-orders/amazon/amazon-canada': amazonCanadaRouteId,
  '/orders/sales-orders/us-foods': usFoodsRouteId,
  '/orders/sales-orders/us-foods/us': usFoodsUsRouteId,
  '/orders/sales-orders/us-foods/us-foods-cs': usFoodsCsRouteId,
  '/orders/sales-orders/us-foods/us-foods-direct': usFoodsDirectRouteId,
  '/orders/sales-orders/gfs': gfsRouteId,
  '/orders/sales-orders/gfs/gfs-us': gfsUsRouteId,
  '/orders/sales-orders/gfs/gfs-canada': gfsCanadaRouteId,
  '/orders/sales-orders/gfs/gfs-stores': gfsStoresRouteId,
  '/orders/sales-orders/store-front': storeFrontRouteId,
  '/orders/sales-orders/admin': adminRouteId,
  '/orders/sales-orders/sysco': syscoRouteId,
  '/orders/sales-orders/sysco/sysco-direct': syscoDirectRouteId,
  '/orders/sales-orders/sysco/european-imports': europeanImportsRouteId,
  '/orders/sales-orders/produce-pro': produceProRouteId,
  '/orders/sales-orders/tao-group': taoGroupRouteId,
  '/orders/sales-orders/legends': legendsRouteId,
  '/orders/sales-orders/four-seasons': fourSeasonsRouteId,
  '/orders/sales-orders/sodexo': sodexoRouteId,
  '/orders/sales-orders/baldor/baldor-df': baldorDfRouteId,
  '/orders/sales-orders/baldor/baldor-warehouse': baldorWarehouseRouteId,
  '/orders/staged-orders/all': stagedOrdersRouteId,
  '/orders/sales-orders/amazon/amazon-seller-central': amazonSellerRouteId,
  '/jobs': jobsRouteId,
  '/product/ideation': ideationProduct,
  '/product/enrichment': enrichProduct,
  '/product/enrichment?active=enrichment': enrichProduct,
  '/product/enrichment?active=working': enrichProduct,
  '/purchasing/container': containerRouteId,
  '/purchasing/container?active=containers': containerRouteId,
  '/purchasing/container?active=action-required': containerRouteId,
  '/purchasing/purchase-order': poRouteId,
  '/purchasing/purchase-order?active=my-po': myPOs,
  '/purchasing/purchase-order?active=hold': onHoldPOs,
  '/purchasing/purchase-order?active=all': allPOs,
  '/purchasing/purchase-order?active=vendor-review': vendorReview,
  '/purchasing/shipment': shipmentRouteId,
  '/inventory-report/incoming-inventory': incomingInventoryRouteId,
  '/inventory-report/archived-inventory': archivedInventoryRouteId,
  '/inventory-report/stock-report': outOfStockRouteId,
  '/inventory-report/in-stock-report': inStockRouteId,
  '/inventory-report/out-stock-report': outOfStockRouteId,
  '/dashboard/edi': ediDashboardRouteId,
  // KPI Dashboard — Vue uses both `/dashboard` (the default landing) and
  // `/dashboard/dashboards` for the listing, plus deep-links like
  // `/dashboard/dashboards/<uuid>` for individual dashboards. All map to
  // the SAME backend `kpiDashboardRouteId`. Mirrors Vue's
  // `route.ts:162-164`.
  '/dashboard': kpiDashboardRouteId,
  '/dashboard/dashboards': kpiDashboardRouteId,
  '/dashboard/sales-summary': salesSummaryRouteId,
  '/dashboard/sales-breakdown': salesBreakdownRouteId,
  '/dashboard/dashboards?view=default': kpiDashboardRouteId,
  '/purchasing/vendors': vendorsRouteId,
  '/purchasing/vendors/approved': approvedRouteId,
  '/purchasing/vendors/pending-approval': pendingApprovalRouteId,
  '/purchasing/vendors/inactive': inActiveRouteId,
  '/inventory-report/all-stocks-report': allProductsInventoryRouteId,
  '/products/export': productExportRouteId,
  '/products/variation-grouping': variationGroupingRouteId,
  '/accounts-receivable/contacts': arContactsRouteId,

  // Returns — Vue parity from `route.ts:170-173`. Four leaves under the
  // Returns rail.
  '/returns': returnRouteId,
  '/returns/view-returns': returnRouteId,
  '/returns/create/customer-support': createCsReturnRouteId,
  '/returns/create/warehouse': warehouseReturnRouteId,
  '/returns/create/unknown-return': unknownReturnRouteId,

  // Pending Catalogs — Vue's `route.ts:174`, leaf under Orders.
  '/orders/pending-catalogs': pendingCatalogsRouteId,

  // Vue-side Shipping Prices path. Vue's AsideMenu uses
  // `/orders/shipping-prices` (line 833) while the React app uses
  // `/shipping-prices` (APP_ROUTES.shippingPrices). Both must
  // resolve to the SAME backend routeId.
  '/orders/shipping-prices': shippingPricesRouteId,

  // Orders → Report Export. Vue's AsideMenu `routeLink: '/orders/report-export'`.
  '/orders/report-export': salesExportRouteId,

  // Leadership rail — Vue's AsideMenu (key 'leadership').
  '/leadership/sample-orders': sampleOrdersRouteId,
  '/leadership/shipment-dashboard': shipmentDashboardRouteId,

  // Shipments rail (top-level, distinct from Purchasing → Shipment) — Vue's
  // AsideMenu (key 'shipments').
  '/shipments/amazon-po': shipmentsAmazonPoRouteId,
  '/shipments/amazon-canada': shipmentsAmazonPoCanadaRouteId,
  '/shipments/us-foods-cs': shipmentsUsFoodsRouteId,
  '/shipments/baldor': shipmentsBaldorRouteId,

  /*
    React-side path aliases — same backend routeId on both sides.

    The Vue ERP's `ROUTE_PERMISSIONS` mapping (the section above) uses
    paths as they appear in Vue's router. React's `menuConfig.ts` uses
    SLIGHTLY DIFFERENT paths for some pages — historical drift between
    the two apps. Without these aliases the React menu silently drops
    menu items whose path doesn't exist in the map (the lookup falls
    through `if (!routeId) return false` in PermissionContext.ts:32),
    and the user sees a DIFFERENT AsideMenu under the same emulated
    identity that Vue renders correctly.

    Each entry maps a React-specific path to the SAME backend routeId
    used by its Vue equivalent, so the permission check resolves to
    the same boolean on both sides.
  */
  // API Keys — React-only feature, backend UUID from tbl_routes
  '/settings/api-keys': apiKeysRouteId,
  '/settings/api-keys/list': apiKeysRouteId,
  '/settings/api-keys/NEW_API_KEY': apiKeysRouteId,
  '/settings/api-keys/:apiKeyId': apiKeysRouteId,
  // AR Contacts — React: /ar-contacts ; Vue: /accounts-receivable/contacts
  '/ar-contacts': arContactsRouteId,
  // CloseHub — React-only feature, real backend UUID from tbl_routes
  // (confirmed 2026-08-06; see the comment on `closeHubRouteId` above).
  // ONE splat route (`AppRoutes.tsx` — `/accounting/closehub/*`) keeps a
  // single <CloseHub /> mounted across all sub-views, but
  // `useLocation().pathname` changes between these four concrete paths as
  // the user switches internal tabs, and RoutePermissionGate checks that
  // pathname — so ALL FOUR must resolve to the SAME grant or a view
  // switch would flash <AccessDenied> mid-session (same shape as the KPI
  // Dashboard entries above).
  '/accounting/closehub': closeHubRouteId,
  '/accounting/closehub/dashboard': closeHubRouteId,
  '/accounting/closehub/checklist': closeHubRouteId,
  '/accounting/closehub/recon': closeHubRouteId,
  // Asana Sourcing / Purchasing dashboards -- per-team route permissions.
  // The base path redirects to Sourcing (see AppRoutes.tsx), so it's
  // gated the same as the Sourcing team path.
  '/sourcing/asana/sourcing': asanaSourcingRouteId,
  '/sourcing/asana/purchasing': asanaPurchasingRouteId,
  // Material Combinations — React menuConfig uses
  // `/products/material-subtype` ; Vue route map uses
  // `/product/material-combinations`. Same domain entity.
  '/products/material-subtype': materialCombinationRouteId,
  // Purchase Orders — React menuConfig uses `/purchasing/po` ;
  // Vue route map uses `/purchasing/purchase-order`.
  '/purchasing/po': poRouteId,
  // All-Products Inventory — React menuConfig uses
  // `/inventory-report/all-products-inventory` ; Vue route map uses
  // `/inventory-report/all-stocks-report`.
  '/inventory-report/all-products-inventory': allProductsInventoryRouteId,
  // Ads & Sales Reconciliation — same path on both sides, Vue's route.ts:111.
  '/marketing/amazon-ads': amazonAdsRouteId,
};
